import { useState, useEffect, useRef } from 'react';
import VideoPlayer from './VideoPlayer';
import StreamInfo from './StreamInfo';
import LiveChat from './LiveChat';
import { useMobile } from '../hooks/useMobile';
import { getToken } from '../hooks/AuthProvider';
import axios from 'axios';
import MuxPlayer from "@mux/mux-player-react"; 
import "@mux/mux-player/themes/classic";
import offlineIMG from '../StreamOfflineBanner.png'
import { gql, useSubscription } from '@apollo/client';
import NumberFlow, { type Value } from "@number-flow/react";

const FOLLOW_COUNT_SUB = gql`
  subscription FollowCount($creatorID: String!) {
    followCount(creatorID: $creatorID)
  }
`;

const STREAM_TITLE_SUB = gql`
  subscription StreamTitleChange($creatorID: String!) {
    streamTitleChange(creatorID: $creatorID)
  }
`;

export const LIVESTREAM_PARTICIPANTS_SUBSCRIPTION = gql`
  subscription LivestreamParticipants($channelID: String!) {
    livestreamParticipants(channelID: $channelID) {
      userID
      channelID
      displayName
      profilePic
      ModStatus
      joinedAt
    }
  }
`;

type streamData = {
    title: string,
    creator: string,
    isLive: boolean
    startedAt: Date,
    viewerCount: number,
    tags: string[],
    playbackID: string,
    playbackToken: string,
    drmToken: string,
    tumbnailToken: string,
    profilePic: string,
    storyboardToken: string,
    creatorID: string
}

interface Participant {
  userID: string;
  channelID: string;
  displayName: string;
  profilePic?: string;
  ModStatus: boolean;
  joinedAt: string;
}

export default function LivestreamLayout() {
    const playerRef = useRef<any>(null);
    const isMobile = useMobile(); 
    // const isMobile = false;
    const [chatVisible, setChatVisible] = useState(true);
    const [streamData, setStreamData] = useState({} as streamData);
    const [viewers, setViewers] = useState(0);
    const [followers, setFollowers] = useState(0 as Value);
    const [participants, setParticipants] = useState<Participant[]>([])

    useEffect(() => {
      let intervalID: NodeJS.Timeout;
      var username = window.location.href.split('/user')[1].split('/')[1];

      axios.get(`${process.env.REACT_APP_API_URL}api/v1/live/${username}`, { headers: { 'x-auth-token': getToken() } }).then((response) => {
        // console.log(response.data);
        setStreamData({
          title: response.data.streamTitle,
          creator: response.data.creator,
          creatorID: response.data.creatorID,
          isLive: response.data.isLive,
          startedAt: response.data.startedAt,
          viewerCount: response.data.viewerCount,
          tags: response.data.streamTags,
          playbackID: response.data.playbackID,
          playbackToken: response.data.playback,
          drmToken: response.data.drm,
          tumbnailToken: response.data.tumbnail,
          profilePic: response.data.profilePic,
          storyboardToken: response.data.storyboard
        });

        if (response.data.followers !== undefined) {
          setFollowers(response.data.followers);
        }

        // console.log(getCount(response.data.playback));

        // Need to get viewer count
        // setInterval(() => {
        //   getCount(response.data.playback)
        // }, 15000)
        // intervalID = setInterval(() => {
        //   getCount(response.data.playback);
        // }, 15000)
      });

      // console.log(url)
      const player = playerRef.current;

      setTimeout(() => {
        // player.play();
        player.muted = false;
        player.volume = 1.0
      }, 1000);

      const hideDialog = () => {
        const shadowRoot = player?.shadowRoot;
        if (!shadowRoot) return;
    
        const dialog = shadowRoot.querySelector('mxp-dialog[open]');
        if (dialog) dialog.remove(); // or dialog.style.display = 'none';
      };
    
      player?.addEventListener('error', hideDialog);
      // return () => player?.removeEventListener('error', hideDialog);

      return () => {
        if (intervalID) {
          clearInterval(intervalID);
        }
        player?.removeEventListener('error', hideDialog)
      }
    }, [])

    const { data: participantData } = useSubscription(
      LIVESTREAM_PARTICIPANTS_SUBSCRIPTION,
      { variables: { channelID: window.location.href.split('/user')[1].split('/')[1] } }
    );

    useEffect(() => {
      if (participantData?.livestreamParticipants) {
        // setParticipants(participantData.livestreamParticipants);
        setViewers(participantData.livestreamParticipants.length);
      }
    }, [participantData])

    useEffect(() => {
      if (streamData.creator) {
        console.log("Subscribing with creatorID:", streamData.creator);
      }
    }, [streamData.creator]);
    
    const { data: followSubData } = useSubscription(FOLLOW_COUNT_SUB, {
      variables: { creatorID: streamData.creatorID },
      skip: !streamData.creator,
    });

    useSubscription(STREAM_TITLE_SUB, {
      variables: { creatorID: streamData.creatorID },
      skip: !streamData.creator,
      onSubscriptionData: ({ subscriptionData }) => {
        const title = subscriptionData.data?.streamTitleChange;
        if (title !== undefined) {
          setStreamData((prev) => ({ ...prev, title }));
        }
      },
    });

    useEffect(() => {
      if (followSubData?.followCount !== undefined) {
        setFollowers(followSubData.followCount);
      }
    }, [followSubData]);

    // useEffect(() => {
    //   if (titleSubData?.streamTitleChange !== undefined) {
    //     console.log(`titleUpdate: ${titleSubData.streamTitleChange}`);
    //     setStreamData((prev) => ({ ...prev, title: titleSubData.streamTitleChange }));
    //   }
    // }, [titleSubData]);

    // const getCount = (token: string) => {
    //   // axios.get(`https://stats.mux.com/counts?token=${token}`).then((data) => {
    //   //   // console.log(data);
    //   //   return data
    //   // })
    //   var username = window.location.href.split('/user')[1].split('/')[1];
    //   axios.get(`${process.env.REACT_APP_API_URL}api/v1/live/${username}/viewers?jwt=${token}`, { headers: { 'x-auth-token': getToken() } }).then((response) => {
    //     setViewers(response.data.viewers.data[0].viewers)
    //     // return response.data;
    //   });
    // }

    const toggleChat = () => setChatVisible(!chatVisible);

    return (
        <div className="container mx-auto px-4 py-6 relative col-span-3 sm:col-span-3 md:col-span-3 lg:col-span-3 xl:col-span-3 2xl:col-span-3">
          <div className="grid grid-cols-12 gap-4">
            {/* Main content area */}
            <div className={`${isMobile || !chatVisible ? "col-span-12" : "col-span-7 xl:col-span-8"} space-y-4`}>
              <MuxPlayer
                ref={playerRef}
                playbackId={streamData.playbackID}
                // @ts-ignore
                playbackToken={streamData.playbackToken}
                drmToken={streamData.drmToken}
                thumbnailToken={streamData.tumbnailToken}
                storyboardToken={streamData.storyboardToken}
                poster={offlineIMG}
                minResolution='1080p'
                accentColor='#dc2626'
                autoplay
                muted
                // nativeControlsForIos
                streamType="live" // or "live", depending on your case
                metadata={{
                  video_title: "Title",
                  viewer_user_id: "user123",
                }}
                playsInline={true}
              />

              <StreamInfo
                title={streamData.title}
                creator={streamData.creator}
                viewerCount={viewers}
                startedAt={streamData.startedAt}
                profilePic={streamData.profilePic}
                tags={streamData.tags}
                followers={Number(followers)}
              />
            </div>
    
            {/* Chat area with animation */}
            {/* {chatVisible && (
              <div
                className={`${isMobile ? "fixed inset-0 z-50 bg-black/80 pt-16" : "col-span-4 xl:col-span-3"} transition-all duration-300 ease-in-out`}
                style={{
                  opacity: 1,
                  transform: "none",
                }}
              >
                <LiveChat onClose={isMobile ? toggleChat : undefined} />
              </div>
            )} */}
            {chatVisible && (
              <div
                className={`${
                  isMobile ? "fixed bottom-0 left-0 right-0 z-50 bg-black/80" : "col-span-5 xl:col-span-4"
                } transition-all duration-300 ease-in-out`}
                style={{
                  opacity: 1,
                  transform: "none",
                }}
              >
                <LiveChat onClose={isMobile ? toggleChat : undefined} />
              </div>
            )}
          </div>

          {isMobile && !chatVisible && (
            <div
              className="fixed bottom-6 right-6 z-40 transition-all duration-300 ease-in-out"
              style={{
                opacity: 1,
                transform: "scale(1)",
              }}
            >
              <button
                onClick={toggleChat}
                className="h-14 w-14 rounded-full bg-gradient-to-r from-purple-600 to-red-600 shadow-lg shadow-purple-900/30 flex items-center justify-center text-white"
              >
                {/* <FontAwesomeIcon icon={faCommentAlt} className="text-xl" /> */}
                <i className="fas fa-comment-alt text-xl"></i>
              </button>
            </div>
          )}
    
          {/* Floating chat toggle button on mobile */}
          {/* {isMobile && !chatVisible && (
            <div
              className="fixed bottom-6 right-6 z-40 transition-all duration-300 ease-in-out"
              style={{
                opacity: 1,
                transform: "scale(1)",
              }}
            >
              <button
                onClick={toggleChat}
                className="h-14 w-14 rounded-full bg-gradient-to-r from-purple-600 to-red-600 shadow-lg shadow-purple-900/30 flex items-center justify-center text-white"
              >
                <MessageSquare className="h-6 w-6" />
              </button>
            </div>
          )} */}
        </div>
      )
}